// Copyright 2026. WebPros International GmbH. All rights reserved.

export const FILTERS = {
    COMPUTE_RESOURCE: 'compute-resource-filter',
    COMPUTE_RESOURCE_VM: 'compute-resource-vm-filter',
    COMPUTE_RESOURCE_VM_STATUS: 'compute-resource-vm-status-filter',
    HIGH_AVAILABILITY_HISTORY_STATUS: 'ha-activity-status-filter',
    BACKUP_NODE: 'backup-node-filter',
    USER: 'user-filter',
    LOCATION: 'location-filter',
    VIRTUALIZATION_TYPE: 'virtualization-type-filter',
    STORAGE_TYPE: 'storage-type-filter',
    FOR_DELETED_SERVERS: 'for-deleted-servers-filter',
    TAG: 'tag-filter',
    HIGH_AVAILABILITY: 'high-availability-filter',
};

export const HEADER = {
    LANGUAGE_DROPDOWN: 'language-dropdown',
    LICENSE_TOP_BAR: 'license-top-bar',
};
